module.exports = __webpack_public_path__ + "img/person.dd6d29a.jpg";